<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Total De HOE {{TitleTypeCCP}}</h1>
</div>


<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">

  <!---================= CONTAINER SELECT TYPE HOE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-chart-simple"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Tipo de reporte</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select [(ngModel)]="ValueTypeCCP" (change)="ChangeTypeCCP()" class="Custom-Form" [searchable]="false"
            [items]="OptionsTypeCCP" bindLabel="item" autofocus [clearable]="false" bindValue="value">
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>

      </div>

    </div>
  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Total De HOE {{TitleTypeCCP}}</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER GENERATE REPORT =================--->
        <div class="Container-Buttons">
          <div class=" Generate-Report-Level">
            {{Data_Report_List.length}}
          </div>
        </div>
      </div>

    </div>

  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <div class="Container-Buttons">

          <div (click)="ReloadPage()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </div>

        </div>
      </div>

    </div>

  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-cloud-arrow-down"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Descargas</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER DOWNLOAD FILE =================--->
        <div class="Container-Buttons">

          <div (click)="DownloadReportXLSX()" class="Btn-Option XLSX button-square">
            <span class="Tool-Tip">Descargar Excel</span>
            <i class="fa-regular fa-file-excel"></i>
          </div>

          <div (click)="DownloadReportPDF()" class="Btn-Option PDF button-square">
            <span class="Tool-Tip">Descargar pdf</span>
            <i class="fa-regular fa-file-pdf"></i>
          </div>

        </div>
      </div>

    </div>

  </div>

</div>


<div class="container-global-components ConRL">
  <div *ngIf="Data_Report_List.length > 0;else Not_CCP_RL" class="Table-Lib Table-container-Global">

    <p-table #dt [value]="Data_Report_List" [(selection)]="SelectedData_Report_List" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','Revision_No','Model_Year','Code','Invoice_4M','Reviewer_Name','Approver_Name']">

      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR HOE SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_RList" type="text"
                (input)="dt.filterGlobal(Filter_RList, 'contains')" placeholder="Buscar en reporte listado" />
            </div>
          </div>
          <div class="right-CT">

          </div>
        </div>

      </ng-template>

      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Header of HeadersRL">

            <ng-container *ngIf="Header.Key_Header==='UBI'">
              <th pSortableColumn="Path" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Path"></p-sortIcon>
                    <p-columnFilter type="text" field="Path" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAM'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='COD'">
              <th pSortableColumn="Code" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Code"></p-sortIcon>
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOR'">
              <th pSortableColumn="Revision_No" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter type="text" field="Revision_No" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='MOY'">
              <th pSortableColumn="Model_Year" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Model_Year"></p-sortIcon>
                    <p-columnFilter field="Model_Year" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Tipo documento</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Model_Year"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>


                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              <th pSortableColumn="Invoice_4M" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Invoice_4M"></p-sortIcon>
                    <p-columnFilter type="text" field="Invoice_4M" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='CON'">
              <th pSortableColumn="Contributor_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Contributor_Name"></p-sortIcon>
                    <p-columnFilter field="Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APP'">
              <th pSortableColumn="Approver_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Name"></p-sortIcon>
                    <p-columnFilter field="Approver_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REV'">
              <th pSortableColumn="Reviewer_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Reviewer_Name"></p-sortIcon>
                    <p-columnFilter field="Reviewer_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Reviewer_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAM'">
              <th pSortableColumn="Date_Modification" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Modification"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Modification" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USASS' && ValueTypeCCP===2">
              <th pSortableColumn="Approver_Assigned" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Assigned"></p-sortIcon>
                    <p-columnFilter field="F_Approver_Assigned" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Usuario Asignado</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Assigned"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USREJ' && ValueTypeCCP===3">
              <th pSortableColumn="Approver_Rejected" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Rejected"></p-sortIcon>
                    <p-columnFilter field="F_Approver_Rejected" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Rejected"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REASO' && ValueTypeCCP===3">
              <th pSortableColumn="Reason_Rejected" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Reason_Rejected"></p-sortIcon>
                    <p-columnFilter type="text" field="Reason_Rejected" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='EST'">
              <th pSortableColumn="Status" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Status" placeholder="Seleccione"
                          (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option">
                                    <div *ngSwitchCase='1'>Aprobada</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazada</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>


          </ng-container>

          <th><i class="fa fa-question-circle"></i></th>
        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-Data_Report_List>

        <tr>

          <ng-container *ngFor="let Header of HeadersRL">
            <ng-container *ngIf="Header.Key_Header==='UBI'">
              <td><div (click)="SeeCCPLibrary(Data_Report_List.Path)">{{Clean_Route(Data_Report_List.Path)}}</div></td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAM'">
              <td>{{Data_Report_List.Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='COD'">
              <td>{{Data_Report_List.Code}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOR'">
              <td>{{Data_Report_List.Revision_No}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='MOY'">
              <td>{{Data_Report_List.Model_Year===0?'N/A':Data_Report_List.Model_Year}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              <td>{{Data_Report_List.Invoice_4M}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='CON'">
              <td>{{Data_Report_List.Contributor_Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APP'">
              <td>{{Data_Report_List.Approver_Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REV'">
              <td>{{Data_Report_List.Reviewer_Name}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAM'">
              <td>{{DateFormat(Data_Report_List.Date_Modification)}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USASS' && ValueTypeCCP===2">
              <td>{{Data_Report_List.Approver_Assigned}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='USREJ' && ValueTypeCCP===3">
              <td>{{Data_Report_List.Approver_Rejected}}</td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REASO' && ValueTypeCCP===3">
              <td>
                <div class="Description">

                  <div class="Text-Description">
                    {{Cut_Reason(Data_Report_List.Reason_Rejected)}}
                  </div>

                  <button (click)="See_Reason(Data_Report_List.Reason_Rejected)"
                    *ngIf="Data_Report_List.Reason_Rejected!==null && Data_Report_List.Reason_Rejected.length > 32"
                    class="Btn-Description">
                    <i class="fa-regular fa-file-lines"></i>
                    <div class="Tool-Tip T-Description">Ver objetivo</div>
                  </button>

                </div>
              </td>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='EST'">
              <td>{{Status_string(Data_Report_List.Status)}}</td>
            </ng-container>

          </ng-container>
          <td>
            <div class="Container-Status">
              <div class="Status-RLH {{Status_Type(Data_Report_List.Status)}}">
              </div>
            </div>
          </td>
        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="Data_Report_List.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <ng-template #Not_CCP_RL>
    <div *ngIf="Load_Page" class="Not-Report-RL">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Not-Report.png" alt="">
      </div>
      <div class="Text-Not-Report-RL">
        No existen HOE {{TitleTypeCCP}} en este directorio.
      </div>
    </div>
  </ng-template>

</div>



<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR REPORT PDF OR XLSX =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando reporte ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>

